import angular from 'angular';
import {
  ssDialogService,
  loaderService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-demo-dialog.controller';
import template from './edit-demo-dialog.html';
import nameMessagesTpl from './name.messages.html';


export class dialogService {
  getOptions($event, {
    demo
  }) {
    return {
      controller,
      controllerAs: 'editDemoDialogVM',
      locals: {
        demo,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.demo.editDemoDialog', [
  ssDialogService,
  loaderService,
  alerts,
])
  .service('editDemoDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.demo.editDemoDialog created');
